import React from "react";
import { EyeOutlined } from "@ant-design/icons";

// import flyer1 from "../../../../../assets/flyer1.jpeg";
// import flyer2 from "../../../../../assets/flyer2.jpeg";
// import flyer3 from "../../../../../assets/flyer3.JPG";
// import flyer4 from "../../../../../assets/flyer4.JPG";

import newFlyer from "../../../../../assets/newFlyers.jpeg";
import newFlyer1 from "../../../../../assets/newFlyers1.jpeg";
import nf from "../../../../../assets/flyer-new.jpeg";
import nf1 from "../../../../../assets/flyer-new-1.jpeg";

const Flyer = () => {
  return (
    <div>
      {/*  Flyers  */}
      {/* <div className='flyer-container'>
        <a href={flyer3} target='_blank' className='flyer-img-container'>
          <img src={flyer3} alt='flyer3' className='flyer' />
        </a>
        <a href={flyer4} target='_blank' className='flyer-img-container'>
          <img src={flyer4} alt='flyer4' className='flyer' />
        </a>
      </div> */}

      {/* <div className='flyer-container'>
        <a href={flyer1} target='_blank' className='flyer-img-container'>
          <img src={flyer1} alt='flyer1' className='flyer' />
        </a>
        <a href={flyer2} target='_blank' className='flyer-img-container'>
          <img src={flyer2} alt='flyer2' className='flyer' />
        </a>
      </div> */}

      <div className='flyer-container'>
        <a href={newFlyer} target='_blank' className='flyer-img-container'>
          <img src={newFlyer} alt='newFlyer' className='flyer' />
        </a>
        <a href={newFlyer1} target='_blank' className='flyer-img-container'>
          <img src={newFlyer1} alt='newFlyer1' className='flyer' />
        </a>
      </div>
      <div className='flyer-container'>

        <a href={nf} target='_blank' className='flyer-img-container'>
          <img src={nf} alt='newFlyer1' className='flyer' />
        </a>
        <a href={nf1} target='_blank' className='flyer-img-container'>
          <img src={nf1} alt='newFlyer1' className='flyer' />
        </a>
      </div>
    </div>
  );
};

export default Flyer;
